import {
  GripDesignSet,
  LumberSpecies,
  LumberTreatmentType,
  PlateGripSummary,
  PlateMaterialProperties,
  PlateType,
  PlateTypeProperties,
} from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getLatestCalculationPropertySet(
  plateType: string,
  tangiblePlateTypesForComboPlateType: readonly string[],
): Promise<PlateMaterialProperties> {
  return DesignService.get(`platePairs/latestCalculationPropertySet/${plateType}`, {
    params: new URLSearchParams({
      tangiblePlateTypesForComboPlateType: tangiblePlateTypesForComboPlateType.join(','),
    }),
  });
}

export function getPlateGripSummary(
  plateType: PlateType,
  tangiblePlateTypesForComboPlateType: readonly PlateType[],
  lumberSpecies: LumberSpecies,
  tangibleLumberSpeciesForComboLumberSpecies: readonly LumberSpecies[],
  lumberTreatmentType: LumberTreatmentType,
  organization: string | null,
): Promise<PlateGripSummary | null> {
  const rawQuery = {
    plateType,
    tangiblePlateTypesForComboPlateType: tangiblePlateTypesForComboPlateType.join(','),
    lumberSpecies,
    tangibleLumberSpeciesForComboLumberSpecies: tangibleLumberSpeciesForComboLumberSpecies.join(','),
    lumberTreatmentType,
  } as Record<string, string>;
  if (organization) rawQuery.organization = organization;
  const query = new URLSearchParams(rawQuery).toString();
  return DesignService.get(`platePairs/gripSummary?${query}`);
}

export function getPlateTypeProperties(
  plateType: string,
  tangiblePlateTypesForComboPlateType: readonly string[],
): Promise<PlateTypeProperties> {
  return DesignService.get(`platePairs/getPlateTypeProperties/${plateType}`, {
    params: new URLSearchParams({
      tangiblePlateTypesForComboPlateType: tangiblePlateTypesForComboPlateType.join(','),
    }),
  });
}

export function getAllPlateTypeProperties(): Promise<PlateTypeProperties[]> {
  return DesignService.get(`platePairs/getPlateTypeProperties`);
}

export function getOrganizationGripValues(): Promise<GripDesignSet[]> {
  return DesignService.get(`platePairs/getOrganizationGripValues`);
}

export function saveOrganizationGripValues(gripValues: GripDesignSet[]) {
  return DesignService.post(`platePairs/saveOrganizationGripValues`, { data: gripValues });
}
